import {
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  styled,
} from '@mui/material';
import { useState, useRef, useEffect, FC } from 'react';

import { filterS3Url } from '../utils/cvHelper';

const IFrame = styled('iframe')(() => ({
  height: '100%',
  width: '100%',
  border: 0,
  overflowY: 'auto',
}));

interface ICVViewModal {
  open: boolean;
  s3url: string | null;
  handleClose: () => void;
}

const CVViewModal: FC<ICVViewModal> = ({ open, s3url, handleClose }) => {
  const [openModal, setOpenModal] = useState(false);
  const [url, setUrl] = useState<{ url: string; type: string } | null>(null);

  const descriptionElementRef = useRef<HTMLElement>(null);
  useEffect(() => {
    (async () => {
      setOpenModal(open);
      if (s3url) {
        const getURL = await filterS3Url(s3url);
        setUrl(getURL);
      }
    })();
    if (openModal) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open, openModal, s3url]);

  return (
    <>
      <Dialog
        open={openModal}
        onClose={handleClose}
        scroll="paper"
        maxWidth="xl"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">CV View</DialogTitle>
        <DialogContent dividers={true} sx={{ height: '900px', width: '900px' }}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
            sx={{ height: '100%' }}
          >
            <>
              {url && (
                <>
                  {url.type == 'image' ? (
                    <img
                      id="imageviewer"
                      src={url.url}
                      style={{ width: '100%' }}
                      alt="CV View Error"
                    />
                  ) : (
                    <IFrame id="imageviewer" title="imageviewer" src={url.url} />
                  )}
                </>
              )}
            </>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CVViewModal;
